<template>
  <div>
    <div class="ts-flex ts-items-center ts-space-x-2">
      <h1 class="ts-font-robot ts-text-base ts-mb-0 ts-uppercase">
        Report to sub task: {{ edit_data.title }}
      </h1>
      <button
        @click.prevent="showFormCreated"
        class="ts-w-6 ts-h-6 ts-bg-blue-500 ts-rounded-full ts-flex ts-items-center ts-justify-center focus:ts-outline-none"
      >
        <Icon type="ios-add" size="20" class="ts-text-white" />
      </button>
    </div>
    <div v-if="isShowCreate">
      <table class="ts-w-full ts-mt-3">
        <thead>
          <tr class="ts-bg-blue-100">
            <th class="ts-font-robot ts-uppercase ts-text-sm ts-py-1 ts-px-2">
              {{ $t('task.productName') }}
            </th>
            <th
              class="ts-font-robot ts-uppercase ts-text-sm ts-py-1 ts-px-2 ts-w-48"
            >
              {{ $t('task.uom') }}
            </th>
            <th
              class="ts-font-robot ts-uppercase ts-text-sm ts-py-1 ts-px-2 ts-w-24"
            >
              {{ $t('task.quantity') }}
            </th>
            <th
              class="ts-font-robot ts-uppercase ts-text-sm ts-py-1 ts-px-2 ts-w-48"
            >
              {{ $t('task.remark') }}
            </th>
            <th
              class="ts-font-robot ts-uppercase ts-text-sm ts-py-1 ts-px-2 ts-w-10 ts-text-center"
            >
              <a href="#" @click.prevent="addRow"
                ><Icon type="md-add-circle" size="25"
              /></a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(p, index) in model.products" :key="index">
            <td class="ts-font-roboto ts-text-base ts-py-1 ts-px-2">
              <Select
                v-model="p.product_id"
                :filterable="true"
                style="width:100%"
                @on-change="onProductChange(p)"
              >
                <Option
                  v-for="item in products"
                  :value="item.product_id"
                  :key="item.product_id"
                  >{{ item.product_name_en }}</Option
                >
              </Select>
            </td>
            <td class="ts-font-roboto ts-text-base ts-py-1 ts-px-2">
              <Select
                v-model="p.uom_id"
                :filterable="true"
                style="width:100%"
                @on-change="onGetPrice(p)"
              >
                <Option
                  v-for="item in uomList(p.product_id)"
                  :value="item.uom_id"
                  :key="item.uom_id"
                  >{{ item.uom_name_en }}</Option
                >
              </Select>
            </td>
            <td
              class="ts-font-roboto ts-text-base ts-text-center ts-py-1 ts-px-2"
            >
              <Input
                type="number"
                v-model.number="p.quantity"
                placeholder="Quantity"
                style="width: 100%"
              />
            </td>
            <td
              class="ts-font-roboto ts-text-base ts-text-center ts-py-1 ts-px-2"
            >
              <Input
                type="text"
                v-model.trim="p.remark"
                placeholder="Remark"
                style="width: 100%"
              />
            </td>
            <td
              class="ts-font-roboto ts-text-base ts-py-1 ts-px-2 ts-text-center"
            >
              <a href="#" @click.prevent="remove(index)"
                ><Icon type="md-close" size="20" class="ts-text-red-600"
              /></a>
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <div class="row">
        <div
          class="col-md-12 ts-flex ts-items-center ts-justify-end ts-space-x-3"
        >
          <ts-button @click.prevent="isShowCreate = false"
            >{{ $t('cancel') }}
          </ts-button>

          <ts-button
            :disabled="loading"
            @click.prevent="onReport"
            color="primary"
            >{{ $t('save') }}</ts-button
          >
        </div>
      </div>
    </div>
    <br />
    <div v-if="!isShowCreate">
      <div v-for="(report, date) in reportList" :key="date">
        <h1 class="ts-border-b ts-border-dashed ts-text-sm">
          {{ date }}
        </h1>
        <div class="ts-pl-12 ts-p-2">
          <table class="ts-w-full">
            <thead>
              <tr style="background-color: #f8f8f9">
                <th class="ts-uppercase ts-text-sm ts-px-2">
                  {{ $t('task.productName') }}
                </th>
                <th class="ts-uppercase ts-text-sm ts-px-2 ts-w-24">
                  {{ $t('task.uom') }}
                </th>
                <th class="ts-uppercase ts-text-sm ts-px-2 ts-w-12">
                  {{ $t('task.quantity') }}
                </th>
                <th class="ts-uppercase ts-text-sm ts-px-2">
                  {{ $t('task.remark') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in report"
                :key="index"
                class="ts-border-b"
              >
                <td class=" ts-text-sm ts-px-2">
                  {{ item.product_name_en }}
                </td>
                <td class=" ts-text-sm ts-px-2">
                  {{ item.uom_name_en }}
                </td>
                <td class=" ts-text-sm ts-text-center ts-px-2">
                  {{ item.quantity }}
                </td>
                <td class=" ts-text-sm ts-px-2">
                  {{ item.remark }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
export default {
  props: ['edit_data'],
  data() {
    return {
      loading: false,
      products: [],
      uom: [],
      errors: new Errors(),
      isShowCreate: false,
      resource: [],
      model: {
        products: [
          {
            product_id: '',
            uom_id: '',
            unit_price: 0,
            remark: ''
          }
        ]
      }
    }
  },
  computed: {
    uomList: vm => productId => {
      let findProduct = vm.products.find(p => p.product_id == productId)
      if (findProduct) {
        return vm.uom.filter(u => u.uom_cat_id == findProduct.uom_cat_id)
      }
      return []
    },
    reportList() {
      if (this.resource) {
        return this.resource.reduce((acc, item) => {
          const { created_date, ...rest } = item
          if (acc[created_date]) {
            acc[created_date].push(rest)
          } else {
            acc[created_date] = [rest]
          }
          return acc
        }, {})
      }

      return []
    }
  },
  created() {
    this.fetchReport()
  },
  methods: {
    ...mapActions('projectMgt/taskProfile', ['formViewModel']),
    ...mapActions('projectMgt/subTaskProfile', ['report', 'getReport']),
    addRow() {
      this.model.products.push({
        product_id: '',
        uom_id: '',
        unit_price: 0
      })
    },
    remove(index) {
      this.model.products.splice(index, 1)
    },
    fetchModel() {
      this.loading = true
      this.formViewModel({
        fnName: 'product,uom'
      })
        .then(response => {
          this.products = response.data.product
          this.uom = response.data.uom
        })
        .finally(() => (this.loading = false))
    },
    onProductChange(row) {
      let findProduct = this.products.find(p => p.product_id == row.product_id)
      let defaultUom = this.uom.find(
        u => u.uom_cat_id == findProduct.uom_cat_id && u.is_default == true
      )
      row.uom_id = defaultUom.uom_id

      this.onGetPrice(row)
    },
    onGetPrice(row) {
      if (row.uom_id) {
        this.loading = true
        this.formViewModel({
          fnName: 'getSalePrice',
          product_id: row.product_id,
          uom_id: row.uom_id
        })
          .then(response => {
            row.unit_price = response.data.getSalePrice[0].sale_price
          })
          .finally(() => (this.loading = false))
      }
    },
    showFormCreated() {
      this.isShowCreate = true
      this.fetchModel()
    },
    onReport() {
      this.loading = true
      this.report({
        id: this.edit_data.id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.isShowCreate = false
          this.clearInput()
          this.fetchReport()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.loading = false))
    },
    fetchReport() {
      this.loading = true
      this.getReport(this.edit_data.id)
        .then(response => {
          this.resource = response.data
          if (this.isShowCreate) {
            this.fetchModel()
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    clearInput() {
      this.model.products = [
        {
          product_id: '',
          uom_id: '',
          unit_price: 0,
          remark: ''
        }
      ]
    }
  }
}
</script>
